"use strict";

define('uikit/modules/token.input',['underscore', 'marionette', 'backbone', '../mixins/component.mixin', '../channel', '../collections/search.results', './token', '../extra/key.codes', '../helper/dom', '../templates'], function (_, Mn, Backbone, ComponentMixin, channel, SearchResultsView, TokenView, KeyCodes, DOMHelper, Templates) {
  var Token = Backbone.Model.extend({
    defaults: {
      text: '',
      value: '',
      textModel: null,
      valueModel: null
    }
  });
  var Tokens = Backbone.Collection.extend({
    model: Token
  });
  var TokenInputView = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'ui visual search',
    childView: TokenView,
    childViewContainer: '.token.box',
    childViewEventPrefix: 'token',
    childViewOptions: function childViewOptions() {
      return {
        single: this.getBoolOption('singleValue'),
        wrappable: true
      };
    },
    template: Templates.UIKit['token.input'],
    options: {
      createOnBlur: true,
      defaultText: 'Text',
      focusOnCreate: true,
      freeText: true,
      icon: '',
      placeholder: 'Click to search',
      separators: [KeyCodes.SEMICOLON_KEY, KeyCodes.COMMA],
      singleValue: true,
      validateToken: null,
      visible: true,
      errorMessageTimeout: 2000
    },
    childEvents: {
      'resultsView:result:selected': 'selectedSearchResult',
      'resultsView:result:active': 'changedActiveSearchResult'
    },
    events: {
      'blur @ui.input': 'handleInputBlur',
      'focus @ui.input': 'handleInputFocus',
      'keydown @ui.input': 'handleInputKeydown',
      'keyup @ui.input': 'handleInputKeyup',
      'click @ui.clearResults': 'handleClearClick',
      'click @ui.tokens .ui.label': 'handleTokensClick',
      'click .prompt': 'handlePromptClick'
    },
    ui: {
      input: '.token.input',
      tokens: '.token.box',
      clearResults: '.token.clear.icon',
      placeholder: '.placeholder'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.collection = new Tokens();
      this.resultsView = new SearchResultsView();
      this.$el.on('touchstart mousedown', '.results .result', _.debounce(_.bind(this.ignoreBlur, this), 0, true));
      this.listenTo(this.collection, 'add remove reset', this._toggleClearVisibility);
    },
    _toggleClearVisibility: function _toggleClearVisibility() {
      var length = this.collection.length;
      if (this.isRendered) {
        if (length) {
          this.ui.clearResults.show();
        } else {
          this.ui.clearResults.hide();
        }
      }
    },
    defineNewTokenObject: function defineNewTokenObject(useInputTextOnly) {
      var tokenObj = {},
        results = this.resultsView,
        selected = results.getSelected(),
        textInput = this.ui.input.text();
      if (selected && !useInputTextOnly) {
        tokenObj.text = selected.text;
        tokenObj.textModel = selected.model;
      } else {
        if (this.singleValue) {
          tokenObj.text = textInput;
        } else {
          tokenObj.text = this.getOption('defaultText');
          tokenObj.value = textInput;
        }
      }
      return tokenObj;
    },
    generateNewToken: function generateNewToken(ignoreFocus, useInputTextOnly) {
      var token = new Token(this.defineNewTokenObject(useInputTextOnly)),
        tokenView = null;
      if (!this.isValidToken(token)) {
        this.showErrorMessageOnPrompt();
        return;
      }
      this.collection.push(token);
      tokenView = this.children.findByModel(token);
      if (this.singleValue || token.get('value')) {
        this._tokenCreated(token, ignoreFocus);
      } else {
        token._newToken = true;
        tokenView.setCursorToStart();
      }
      this.hideResultsView();
      this.ui.input.text('');
    },
    isValidToken: function isValidToken(token) {
      if (_.isFunction(this.getOption('validateToken'))) {
        try {
          var response = this.getOption('validateToken').call(this, token);
          if (_.isString(response)) {
            this.previousErrorMessage = response;
          } else {
            this.previousErrorMessage = null;
          }
          if (response !== true) {
            return false;
          }
        } catch (e) {
          if (_.isString(e.message)) {
            this.previousErrorMessage = e.message;
          } else {
            this.previousErrorMessage = null;
          }
          return false;
        }
      }
      return true;
    },
    focusCursorOnInput: function focusCursorOnInput() {
      var input = this.ui.input.get(0);
      if (document.activeElement === input) {
        return;
      }
      DOMHelper.placeCaretAtEnd(input);
    },
    handleClearClick: function handleClearClick(ev) {
      var tokens = this.collection.models.slice(0),
        self = this;
      tokens.forEach(function (token) {
        self.collection.remove(token);
        self.triggerMethod('token:remove', token);
      });
      this.resetSearchView();
      ev.stopPropagation();
    },
    handleTokensClick: function handleTokensClick(ev) {
      ev.stopPropagation();
    },
    handlePromptClick: function handlePromptClick(ev) {
      this.resetIgnoreFlag();
      ev.preventDefault();
      this.hidePlaceholder();
      this.focusCursorOnInput();
      this.triggerMethod('search:results:text', this.ui.input.text());
    },
    handleInputFocus: function handleInputFocus() {
      this.hidePlaceholder();
      this.trigger('focus');
    },
    handleInputBlur: function handleInputBlur(ev) {
      if (!this._ignoreBlur) {
        var self = this;
        _.defer(function () {
          var textContent = self.ui.input.text();
          if (self.createOnBlur && textContent.length > 0 && self.freeText) {
            self.generateNewToken(true, true);
          } else {
            self.ui.input.text('');
          }
          self.resetSearchView();
        });
      }
      this.resetIgnoreFlag();
    },
    shouldCreateToken: function shouldCreateToken() {
      var textContent = this.ui.input.text();
      return textContent && this.freeText || !this.isResultsEmpty() && this.resultsView.getSelected();
    },
    showErrorMessageOnPrompt: function showErrorMessageOnPrompt() {
      var message = this.previousErrorMessage || 'Invalid Entry',
        self = this;
      this.ui.input.popup('destroy').popup({
        on: 'manual',
        position: 'top center',
        inline: true,
        content: message,
        variation: 'inverted'
      }).popup('show');
      _.defer(function () {
        self.once('keyup', function () {
          self.ui.input.popup('hide');
        });
      });
      if (this.errorMessageTimeout > -1) {
        setTimeout(function () {
          self.ui.input.popup('hide');
        }, this.errorMessageTimeout);
      }
    },
    resetSearchView: function resetSearchView() {
      this.hideResultsView();
      this.showPlaceholder();
    },
    ignoreBlur: function ignoreBlur() {
      this._ignoreBlur = true;
    },
    resetIgnoreFlag: function resetIgnoreFlag() {
      this._ignoreBlur = false;
    },
    showPlaceholder: function showPlaceholder() {
      if (!(this.collection && this.collection.length) && !this.ui.input.text().length) {
        this.ui.placeholder.show();
      }
    },
    hidePlaceholder: function hidePlaceholder() {
      this.ui.placeholder.hide();
    },
    changedActiveSearchResult: function changedActiveSearchResult(v, result) {
      if (!this.singleValue) {
        if (this.selected) {
          if (result) {
            this.selected.setDetail(result.text);
          } else {
            this.selected.resetDetail();
          }
        }
      }
    },
    selectedSearchResult: function selectedSearchResult(results, selected) {
      if (!this.selected) {
        this.generateNewToken();
      } else {
        if (!this.getOption('singleValue')) {
          this.selected.detail = selected.text;
        }
        this.selected.completeEdit();
      }
    },
    isKeyCodeTokenSeparator: function isKeyCodeTokenSeparator(keyCode) {
      var separators = this.getOption('separators') || [],
        separatorKeyCode = null;
      if (_.isArray(separators)) {
        for (var s = 0, numOfSeparators = separators.length; s < numOfSeparators; s++) {
          separatorKeyCode = separators[s];
          if (!_.isNumber(separatorKeyCode)) {
            continue;
          }
          if (separatorKeyCode == keyCode) {
            return true;
          }
        }
      }
      return false;
    },
    handleInputKeydown: function handleInputKeydown(ev) {
      var tokens = this.children,
        keyCode = ev.keyCode,
        preInputTextContent = this.ui.input.text();
      this._oldTextContent = preInputTextContent;
      if (keyCode === KeyCodes.ENTER_KEY) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.TAB_KEY && preInputTextContent) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.TAB_KEY) {
        DOMHelper.clearSelection();
      } else if (keyCode === KeyCodes.BACKSPACE_KEY) {
        if (!preInputTextContent.length && tokens.length) {
          DOMHelper.clearSelection();
          this.resetSearchView();
          tokens.findByIndex(tokens.length - 1).setFocus();
          ev.preventDefault();
        }
      } else if (keyCode === KeyCodes.DOWNARROW_KEY) {
        ev.preventDefault();
        this.resultsView.selectNextResult();
      } else if (keyCode === KeyCodes.UPARROW_KEY) {
        ev.preventDefault();
        this.resultsView.selectPreviousResult();
      } else if (this.isKeyCodeTokenSeparator(keyCode)) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.ESCAPE_KEY) {
        ev.preventDefault();
        this.resetSearchView();
      }
    },
    handleInputKeyup: function handleInputKeyup(ev) {
      var keyCode = ev.keyCode,
        textContent = this.ui.input.text();
      if (keyCode === KeyCodes.DOWNARROW_KEY) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.UPARROW_KEY) {
        ev.preventDefault();
      } else if (keyCode === KeyCodes.ENTER_KEY || keyCode === KeyCodes.TAB_KEY || this.isKeyCodeTokenSeparator(keyCode)) {
        ev.preventDefault();
        if (this.shouldCreateToken()) {
          this.generateNewToken();
        } else {
          this.hideResultsView();
        }
      } else {
        if (keyCode == KeyCodes.BACKSPACE_KEY && !textContent.length) {
          this.ui.input.html('');
        }
        if (this._oldTextContent != textContent) {
          this.triggerMethod('search:results:text', textContent);
        }
        this._oldTextContent = '';
      }
      this.triggerMethod('keyup', ev);
    },
    hideResultsView: function hideResultsView() {
      this.resultsView.collection = null;
    },
    isResultsEmpty: function isResultsEmpty() {
      return !(this.resultsView.collection && this.resultsView.collection.length);
    },
    onRender: function onRender() {
      this._toggleClearVisibility();
      this.showPlaceholder();
    },
    onTokenKeypress: function onTokenKeypress(token, ev) {
      var keycode = ev.keyCode;
      if (keycode == KeyCodes.DOWNARROW_KEY) {
        this.resultsView.selectNextResult();
      } else if (keycode == KeyCodes.UPARROW_KEY) {
        this.resultsView.selectPreviousResult();
      } else if (keycode == KeyCodes.ENTER_KEY) {
        var selected = this.resultsView.getSelected();
        if (selected) {
          if (!this.getOption('singleValue')) {
            token.detail = selected.text;
          }
        }
        token.completeEdit();
      }
    },
    onTokenClose: function onTokenClose(v) {
      var self = this;
      this.selected = null;
      v.hide({
        animation: 'scale',
        onComplete: function onComplete() {
          self.collection.remove(v.model);
          self.triggerMethod('token:remove', v.model);
          self.focusCursorOnInput();
        }
      });
    },
    onTokenValueEdit: function onTokenValueEdit(v, value) {
      this.triggerMethod('search:results:value', value, v.text);
    },
    onTokenComplete: function onTokenComplete(v) {
      DOMHelper.clearSelection();
      if (v.model._newToken) {
        this._tokenCreated(v.model);
        v.model._newToken = false;
      } else {
        this._tokenRevised(v.model);
      }
    },
    onTokenEditing: function onTokenEditing(v) {
      var multiValue = !this.getOption('singleValue'),
        self = this;
      if (!v.selected) {
        this.selectToken(v);
      }
      v.editing = true;
      if (multiValue) {
        _.defer(function () {
          self.triggerMethod('search:results:value', v.detail, v.text);
        });
      }
    },
    onTokenNotEditing: function onTokenNotEditing(v) {
      v.editing = false;
      this.hideResultsView();
    },
    onTokenDeselect: function onTokenDeselect(v) {
      this.selected = null;
      v.selected = false;
    },
    onTokenSelected: function onTokenSelected(v) {
      this.selectToken(v);
    },
    _tokenCreated: function _tokenCreated(token, ignoreFocus) {
      if (this.focusOnCreate && !ignoreFocus) {
        DOMHelper.clearSelection();
        this.ui.input.focus();
      }
      this.triggerMethod('token:add', token);
    },
    _tokenRevised: function _tokenRevised(token) {
      this.triggerMethod('token:revised', token);
    },
    selectToken: function selectToken(v) {
      this.selected = v;
      this.children.without(v).forEach(function (c) {
        c.selected = false;
        c.editing = false;
      });
      v.selected = true;
    },
    updateAttributes: function updateAttributes() {
      this.addClass('icon', this.getBoolOption('icon'));
    },
    getTokens: function getTokens() {
      return this.collection;
    },
    setTokens: function setTokens(tokens) {
      if (_.isArray(tokens)) {
        this.collection.reset(tokens);
      } else {
        this.collection.reset(tokens.models);
      }
      return this;
    },
    setSearchResults: function setSearchResults(results) {
      if (_.isArray(results)) {
        results = new Backbone.Collection(results);
      }
      this.resultsView.collection = results;
      return this;
    },
    setSearchResultBindings: function setSearchResultBindings(bindings) {
      this.resultsView.childBindings = bindings;
      return this;
    }
  });
  TokenInputView.Token = Token;
  TokenInputView.Tokens = Tokens;
  channel.reply('token-input', function () {
    return TokenInputView;
  });
  return TokenInputView;
});

